export default {"src":"/_next/static/media/mobileTrendingStore.fa93170e.svg","height":100,"width":375};